import Vue from 'vue';
import VueRouter from 'vue-router';
import VueResource from 'vue-resource';
import { routes } from './routes';
import { requireAuthPages } from './requireAuthPages'
 


Vue.use(VueRouter );
Vue.use( VueResource);

 


export const router = new VueRouter({
    routes: routes,
    mode: 'history'
});




 

router.beforeEach((to, from, next) => {
    //const redirectPagesArray = localStorage.getItem('RedirectPages');
   // const redirectPages = JSON.parse(redirectPagesArray);
    //if (redirectPages) {
    //    for (var i = 0; i < redirectPages.length; i++) {
    //        var path = redirectPages[i];
    //        console.log('path to', to.fullPath);
    //        console.log('old', path.OldPath);
    //        if (to.fullPath === path.OldPath) {
    //            next(path.NewPath);
    //            return;
    //        }
    //    }
    //} else {
    //    next();  
    //}
    var authRequired = false;
    for (var i = 0; i < requireAuthPages.length; i++) {
        if (to.path.startsWith(requireAuthPages[i])) {
            authRequired = true;
            break;
        }
    }

    if (authRequired) {
        var accessToken = localStorage.getItem('accessToken');
        if (accessToken == '' || accessToken == null)
            return next('/loginWithMobile?returnUrl=' + to.path);
    }
    next(true);
 
})